import React from 'react';
import {useEffect} from 'react';

const DisableZoom = () => {
  useEffect(() => {
    // Create or update the meta tag
    let metaTag = document.querySelector(
      'meta[name="viewport"]',
    ) as HTMLMetaElement;

    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.name = 'viewport';
      document.head.appendChild(metaTag);
    }

    const originalContent = metaTag.content;

    metaTag.content = 'width=device-width, initial-scale=1, user-scalable=no';

    const onTouchstart = function (e: any) {
      if (e.touches.length > 1) e.preventDefault();
    };

    const onGestureStart = function (e: any) {
      e.preventDefault();
    };

    const lockScroll = (e: TouchEvent) => {
      e.preventDefault();
    };

    document.addEventListener('touchstart', onTouchstart, {passive: false});

    document.addEventListener('gesturestart', onGestureStart, {passive: false});

    document.addEventListener('touchmove', lockScroll, {passive: false});

    const originalStyle = {
      overflowX: document.body.style.overflowX,
      overscrollBehavior: document.body.style.overscrollBehavior,
    };

    document.body.style.overflowX = 'hidden';
    document.body.style.overscrollBehavior = 'none';

    return () => {
      metaTag.content = originalContent;
      document.removeEventListener('touchstart', onTouchstart);
      document.removeEventListener('gesturestart', onGestureStart);
      document.removeEventListener('touchmove', lockScroll);
      document.body.style.overflowX = originalStyle.overflowX;
      document.body.style.overscrollBehavior = originalStyle.overscrollBehavior;
    };
  }, []);
  return <></>;
};

export default React.memo(DisableZoom);
